import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { registerAdmin } from "./slices/AdminSlice";
import { useNavigate, Link } from "react-router-dom";
import './styles/auth.css';  // Import the CSS file

const AdminRegister = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.admin);
  const [formData, setFormData] = useState({
    name: "",
    businessName: "",
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData((f) => ({ ...f, [e.target.name]: e.target.value }));
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    const result = await dispatch(registerAdmin(formData));
    
    if (registerAdmin.fulfilled.match(result)) {
      // After successful registration, redirect to /admin or admin subdomain
            localStorage.setItem("admin", "true");

      navigate("/admin");
    }
  };

  return (
    <div className="auth-wrapper">
  <div className="auth-form">
      <h2>Register Admin</h2>
      <form onSubmit={handleRegister}>
        <input
          name="name"
          placeholder="Name"
          value={formData.name}
          onChange={handleChange}
        />
        <input
          name="businessName"
          placeholder="Business Name"
          value={formData.businessName}
          onChange={handleChange}
        />
        <input
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
        />
        <input
          name="password"
          placeholder="Password"
          type="password"
          value={formData.password}
          onChange={handleChange}
        />
        <button type="submit" disabled={loading}>
          {loading ? "Registering..." : "Register"}
        </button>
        {error && <p className="error">{error}</p>}
      </form>
      <p>
        Already have an account? <Link to="/admin/login">Login here</Link>
      </p>
    </div>
    </div>
  
  );
};

export default AdminRegister;
